class customJS {
    constructor() {
        this.collectionCollapse();
    }

    collectionCollapse(){
        let readMoreElement = document.querySelectorAll('[data-read-more-coll]');
        for(let i=0; i<readMoreElement.length; i++){
            readMoreElement[i].addEventListener('click', function(){
                let menuItem =  readMoreElement[i].closest('.collection-hero__text-wrapper');
                let readMoreItem = menuItem.querySelector('.read-more-content');
                let shortContent = menuItem.querySelector('.short-content');

                let readLess = menuItem.querySelector('.read-less');
                let readMore = menuItem.querySelector('.read-more');
                shortContent.classList.add('d-none');
                shortContent.classList.remove('d-block');
                readMore.classList.add('d-none');
                readMore.classList.remove('d-block');
                readMoreItem.classList.add('open');
                readLess.classList.add('d-block');
                readLess.classList.remove('d-none');
            });
        }
        let readLessElement = document.querySelectorAll('[data-read-less-coll]');
        for(let i=0; i<readLessElement.length; i++){
            readLessElement[i].addEventListener('click', function(){
                let menuItem =  readLessElement[i].closest('.collection-hero__text-wrapper');
                let readMoreItem = menuItem.querySelector('.read-more-content');
                let shortContent = menuItem.querySelector('.short-content');
                let readMore = menuItem.querySelector('.read-more');
                let readLess = menuItem.querySelector('.read-less');
                shortContent.classList.add('d-block');
                shortContent.classList.remove('d-none');
                readMoreItem.classList.remove('open');
                readMore.classList.add('d-block');
                readMore.classList.remove('d-none');
                readLess.classList.add('d-none');
                readLess.classList.remove('d-block');
            });
        }

    }
}

typeof customJS !== 'undefined' && new customJS();

$(document).on('change','.product-form__select_class', function() {
  console.log('changed');
  if(this.value == ''){
    console.log('11');
    $('.product-form__submit').addClass('atc_disable_class');
    $('.product-form__submit').find('span:first-child').text('Choose Option');
  }else{
    console.log('22');
    $('.product-form__submit').removeClass('atc_disable_class');
  }
});